import Deferred from './lib/deferred-shim';

function serializeParams(data) {
    var params = new URLSearchParams();
    Object.keys(data).forEach(function(key) {
        var value = data[key];
        if (Array.isArray(value)) {
            value.forEach(function(v) { params.append(key, v); });
        } else if (value !== null && value !== undefined) {
            params.append(key, value);
        }
    });
    return params.toString();
}

function apiCall(type, isJSONBody, url, data, prevDeferred, timeout) {
    data = data || {};

    // work around for a limitation where
    // we can't use multiple conrollers in
    // clarive plugin
    if (url.indexOf('/') !== 0) {
        var parts = url.split(/\//);

        var plugin = parts.shift();
        var path = parts.join('/');

        data.path = path;
        url = '/plugin/' + plugin;
    }

    var deferred = prevDeferred || Deferred();
    var promise = deferred.promise();

    // Claude Code: Inject X-Simulate-User header when simulation is active (tab-scoped)
    var headers = { 'x-clarive-request': '1' };
    var simulateUserData = sessionStorage.getItem('clarive-simulate-user');
    if (simulateUserData) {
        try {
            var parsed = JSON.parse(simulateUserData);
            headers['x-simulate-user'] = parsed.username;
        } catch (e) {
            headers['x-simulate-user'] = simulateUserData;
        }
    }

    // Build fetch options
    var fetchOptions = {
        method: type,
        headers: headers,
        credentials: 'same-origin'
    };

    // Handle data serialization
    if (isJSONBody) {
        headers['Content-Type'] = 'application/json';
        fetchOptions.body = typeof data === 'object' ? JSON.stringify(data) : data;
    } else if (type === 'GET') {
        var qs = serializeParams(data);
        // Cache busting (replaces jQuery cache: false)
        qs += (qs ? '&' : '') + '_=' + Date.now();
        url += (url.indexOf('?') !== -1 ? '&' : '?') + qs;
    } else {
        headers['Content-Type'] = 'application/x-www-form-urlencoded';
        fetchOptions.body = serializeParams(data);
    }

    // Timeout via AbortController
    var controller, timer;
    if (timeout) {
        controller = new AbortController();
        fetchOptions.signal = controller.signal;
        timer = setTimeout(function() { controller.abort(); }, timeout);
    }

    if (global.Cla && Cla.app) Cla.app.startLoading();

    fetch(url, fetchOptions)
        .then(function(response) {
            if (timer) clearTimeout(timer);
            if (global.Cla && Cla.app) Cla.app.stopLoading();

            if (response.status === 401) {
                Cla.login({
                    no_reload: true,
                    on_login: function() {
                        apiCall(type, isJSONBody, url, data, deferred);
                    }
                });
                return;
            }

            if (!response.ok) {
                return response.text().then(function(text) {
                    deferred.reject({ status: response.status, responseText: text, statusText: response.statusText });
                });
            }

            return response.text().then(function(text) {
                var responseData;
                try {
                    responseData = JSON.parse(text);
                } catch (e) {
                    responseData = text;
                }
                deferred.resolve(responseData);
            });
        })
        .catch(function(err) {
            if (timer) clearTimeout(timer);
            if (global.Cla && Cla.app) Cla.app.stopLoading();

            deferred.reject({ status: 0, responseText: err.message, statusText: 'error' });
        });

    return promise;
}

/**
 *  api methods exports
 */
export default {
    get: function(url, data) {
        return apiCall('GET', false, url, data);
    },
    post: function(url, data) {
        return apiCall('POST', false, url, data);
    },
    postJSON: function(url, data, timeout) {
        return apiCall('POST', true, url, data, undefined, timeout);
    }
};
